// V3
export const financierParser = financier => {
  const financierData = {
    financierName: financier?.name,
    financierPAN: financier?.code,
    financierId: financier?.id,
    referralCode: financier?.referral_code,
    walletId: financier?.wallet_id,
    walletBalance: financier?.wallet_balance,
    fixedIRR: financier?.fixed_net_irr_to_be_given_to_investor_percentage,
    enableBuyButton: financier?.enable_buy_button,
    authorizedUser: {
      id: financier?.authorized_user?.id,
      fullName: financier?.authorized_user?.full_name,
      PAN: financier?.authorized_user?.pan,
      aadhaarNumber: financier?.authorized_user?.masked_aadhaar,
      emailId: financier?.authorized_user?.email,
      phone: financier.authorized_user?.phone,
      phoneNumber: '+' + financier?.authorized_user?.country_code + ' ' + financier.authorized_user?.phone,
    },
    escrow: {
      accountNumber: financier?.financier_escrow_bank_account?.account_number,
      holderName: financier?.financier_escrow_bank_account?.account_holder_name,
      bankName: financier?.financier_escrow_bank_account?.bank_name,
      IFSC: financier?.financier_escrow_bank_account?.ifsc,
      branch: financier?.financier_escrow_bank_account?.branch,
      branchAddress: financier?.financier_escrow_bank_account?.branch_address,
    },
    financierBank: {
      id: financier?.financier_bank_account?.id,
      accountNumber: financier?.financier_bank_account?.account_number,
      holderName: financier?.financier_bank_account?.account_holder_name,
      bankName: financier?.financier_bank_account?.bank_name,
      IFSC: financier?.financier_bank_account?.ifsc,
    },
  }

  return financierData
}
